export const PDF_DEFAULT_LEFT_MARGIN = 40;
export const PDF_DEFAULT_WIDTH = 550;
export const PDF_DEFAULT_HEIGHT = 0;
